import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';

/** Link cards, one column on a phone and two from md. */
export function LinkCardGrid({ children }: { children: ReactNode }) {
  return <div className="link-card-grid">{children}</div>;
}

/**
 * A title over a short text, the whole card one link — for an index page
 * whose entries need a sentence each to be picked without opening them.
 */
export function LinkCard({
  to,
  title,
  children,
}: {
  to: string;
  title: string;
  children: ReactNode;
}) {
  return (
    <Link to={to} className="link-card">
      <span className="link-card-title">{title}</span>
      <div className="link-card-text">{children}</div>
    </Link>
  );
}
